<form (ngSubmit)="onSubmit(form)" #form="ngForm">
	<div>
		<div class="flex justify-between mb-4">
			<span class="text-xl">{{ modalTitle() }}</span>

			<img
				class="w-[15%] h-[15%]"
				src="/assets/images/integrations/ghost-practice-logo.png "
				alt="GhostPractice logo"
			/>
		</div>
	</div>

	<mat-dialog-content class="max-w-[1200px] min-w-[800px]">
		@if (editableCodes().length === 0) {
			<div class="gap-y-4 flex gap-x-4">
				<div class="grid grid-cols-1 gap-4 w-full">
					<div>
						<h4>Import Accounting Codes</h4>
						<p>
							Import your GhostPractice accounting codes CSV file here. The file
							should contain activity codes with their corresponding GL
							accounts.
						</p>
					</div>

					<atomic-dropzone
						#codesDropzone
						[class.hidden]="storedFileName()"
						(fileChanged)="onCodesFileSelected($event)"
						accept=".csv"
						label="GhostPractice codes CSV"
						[multiple]="false"
					></atomic-dropzone>
				</div>
			</div>
		}

		@if (editableCodes().length > 0) {
			<div class="mt-2">
				<div class="flex gap-x-4">
					<div class="flex flex-col border rounded p-4 w-1/4">
						<div>
							<atomic-file-upload
								btnLabel="Import new"
								[fileName]="storedFileName()"
								type="stacked"
								(fileSelected)="onCodesFileSelected($event)"
								[fileTypeList]="['csv']"
								label="Codes File"
								[multiple]="false"
							></atomic-file-upload>
						</div>
						<hr class="my-4" />
						<div>
							<div class="bg-blue-lighter p-4 rounded">
								<p>
									<app-icon [icon]="ICON.LIGHT_BULB"></app-icon> To edit, add,
									or delete codes, make changes within GhostPractice and
									re-import the CSV file here.
								</p>
							</div>
						</div>
					</div>

					<div class="w-3/4 grid grid-cols-7 rounded border gap-2">
						<div
							class="grid grid-cols-7 bg-grey-veryLight gap-x-4 col-span-7 py-4"
						>
							<div class="col-span-1 bg-grey-veryLight rounded-l my-auto">
								<h4 class="text-base m-0 ml-2">ID</h4>
							</div>
							<div class="col-span-1 bg-grey-veryLight my-auto">
								<h4 class="text-base m-0">Taxable</h4>
							</div>
							<div class="col-span-2 bg-grey-veryLight my-auto">
								<h4 class="text-base m-0">Description</h4>
							</div>
							<div class="col-span-2 bg-grey-veryLight my-auto">
								<h4 class="text-base m-0">
									Type
									<app-icon
										class="ml-2 text-grey-light"
										matTooltip="Type specifies whether each code should be available for fees and/or disbursements."
										[icon]="ICON.INFO"
									></app-icon>
								</h4>
							</div>
							<div class="col-span-1 bg-grey-veryLight my-auto">
								<h4 class="text-base m-0">G/L Account</h4>
							</div>
						</div>

						<div class="col-span-7 overflow-y-auto h-[400px]">
							@for (code of editableCodes(); track code.id; let i = $index) {
								<div
									class="p-2 grid grid-cols-7 gap-x-4 overflow-auto min-h-0 h-[100px]"
								>
									<div class="col-span-1 mt-4">
										<p>{{ code.id }}</p>
									</div>
									<div class="col-span-1 mt-4">
										<p>{{ code.taxApplies ? 'Yes' : 'No' }}</p>
									</div>
									<div class="col-span-2 mt-4">
										<p>{{ code.description }}</p>
									</div>
									<div class="col-span-2 mt-4 my-2">
										<app-dropdown
											[autoSelectLabel]="true"
											[submitted]="form.submitted"
											[required]="true"
											[name]="'type' + i"
											[(ngModel)]="code.type"
											[itemGroups]="[{ items: codeTypesDropdownOptions }]"
											[disabled]="true"
										></app-dropdown>
									</div>
									<div class="col-span-1 mt-4 ml-2">
										<p>{{ code.glAccount }}</p>
									</div>
								</div>
							}
						</div>
					</div>
				</div>
			</div>
		}
	</mat-dialog-content>

	<mat-dialog-actions class="p-4">
		<div class="w-full">
			@if (editableCodes().length > 0) {
				<div class="flex justify-end gap-x-4 mt-4">
					<ui-button
						label="Cancel"
						color="gray"
						[style]="'outline'"
						mat-dialog-close
					></ui-button>
					<ui-button label="Save" type="submit"></ui-button>
				</div>
			}

			@if (editableCodes().length === 0) {
				<div class="flex justify-end">
					<ui-button
						label="Cancel"
						color="gray"
						[style]="'outline'"
						mat-dialog-close
					></ui-button>
				</div>
			}
		</div>
	</mat-dialog-actions>
</form>
